export const API_URL = 'https://api.muslapp.com/api';
export const S3_URL = 'https://d4yl8j6o7jvin.cloudfront.net';

export const APPLE_STORE_LINK = 'https://apps.apple.com/us/app/heyheyhey/id1547445036'
export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.heyheyhey'
export const SITE_URL = 'https://heyheyheyapp.com/'
export const PRIVACY_POLICY_LINK = 'https://heyheyheyapp.com/privacy-policy/'
export const TERMS_AND_CONDITIONS_LINK = 'https://heyheyheyapp.com/terms-of-use/'
